import React from 'react';
import PropTypes from 'prop-types';

import './ButtonBar.scss';

const ButtonBar = ({ children }) => {
  return (
    <div className="row screening-button-bar">
      <div
        className="row col-xs-12 screening-button-bar-box"
        style={{ paddingLeft: '10px' }}
      >
        {children}
      </div>
    </div>
  );
};

ButtonBar.propTypes = {
  children: PropTypes.node,
};

export default ButtonBar;
